<template>
	<div class="chat-image">
		<div v-for="(image, index) in images" :key="image.id">
			<ImageModal :img-url="modalImage" :dialog.sync="dialog" />
			<img
				class="pa-1"
				@load="onLastImageLoad(index)"
				:src="image.media_link"
				@click="showDialog(image)"
				alt="image"
			/>
		</div>
	</div>
</template>

<script>
import ImageModal from '@/components/Chat/parts/ImageModal'

export default {
	components: {
		ImageModal,
	},
	props: {
		images: {
			type: Array,
			default: () => [],
		},
		id: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			imgSrc: '',
			modalImage: '',
			dialog: false,
		}
	},
	methods: {
		showDialog(image) {
			this.dialog = true
			this.modalImage = image.media_link
		},
		onLastImageLoad(index) {
			if (index === this.images.length - 1) {
				this.$emit('imageLoad')
			}
		},
	},
}
</script>

<style lang="scss">
.chat-image {
	max-width: 500px;

	img {
		width: 100%;
		border-radius: 10px;
		cursor: pointer;
	}
}
</style>
